import { buildProductArgs } from 'Utils/graphql';
export const getProductBarsQuery = (productId: string) => {
  const productArgs = buildProductArgs(productId);
  return `
  query {
    resort(${productArgs}) {
      facilities(types: ["BARS"]) {
        additionalDescription
        id
        images
        label
        menu {
          label
          href
        }
        openingDays {
          businessHours {
            closing
            label
            opening
          }
          day
        }
        reservationLink
        subtitle
        type
      }
    }
  }`;
};
